import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useClipboard, useToast, Select, Flex } from "@chakra-ui/react";
import ReactSelect from "react-select";

import AssessmentDataService from "../../../services/Assessment";
import ExpertDataService from "../../../services/Expert";

export const GeneratePaymentLink = () => {
  const token = localStorage.getItem("logged_in_user_token");

  const toast = useToast();
  const navigate = useNavigate();
  const { onCopy, value, setValue, hasCopied } = useClipboard("");
  const [amount, setAmount] = useState("");
  const [link, setLink] = useState("");
  const [expertName, setExpertName] = useState("");
  const [bookingType, setBookingType] = useState("");
  const [sessionType, setSessionType] = useState("");
  const [expertList, setExpertList] = useState<any>([]);

  const [customer, setCustomer] = useState({
    name: "",
    contact: "",
    email: "",
  });
  const [notify, setNotify] = useState({
    email: false,
    sms: false,
  });
  const [isLink, setIsLink] = useState(false);


  const [expertInformation, setExpertInformation] = useState({
    uuid: "",
    full_name: "",
    role: "",
  });

  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const handleGenerateLink = () => {
    if (amount !== "" && !isNaN(Number(amount)) && expertInformation.full_name !== "") {
      // const expertObj = SuggestedExperts.find(
      //   (el: any) => el.value === expertName
      // ) || { label: "" };
      // const expert = expertObj.label;

      const hasCustomerInfo = Object.values(customer).some((val) => val !== "");

      const obj: any = {
        amount: amount,
        description: `RPL_${sessionType}_${bookingType}_SESSION_WITH_${expertInformation.full_name}_${expertInformation.uuid}`,
        notify: notify,
      };

      if (hasCustomerInfo) {
        obj.customer = customer;
      }

      AssessmentDataService.getBasicPaymentLink(obj, token)
        .then((res) => {
          setIsLink(true);
          setLink(res.data);
          setValue(res.data);
          navigate("/assessment/payments");
        })
        .catch((e) => {
          const response = e.response.data;
          toast({
            position: "top",
            title: "Error Generating Link.",
            description: response.message,
            status: "error",
            duration: 1000,
            isClosable: true,
          });
        });
    } else {
      toast({
        position: "top",
        title: "Enter Valid Amount",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    }
  };

  const fetchExperts = async () => {
    try {
      const expertRes = await ExpertDataService.getExperts(token);
      setExpertList(expertRes.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleExpertDetails = (value: any) => {
    const data = expertList.find((el: any) => el._id === value);
    if (data) {
      setExpertInformation({
        ...expertInformation,
        uuid: value,
        full_name: data.data.full_name,
        role: data.data.role,
      });
    } else {
      setExpertInformation({
        uuid: "",
        full_name: "",
        role: "",
      });
    }
  };

  useEffect(() => {
    setIsLink(false);
    fetchExperts();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Payment</div>
      <div className="p-5">
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            <h4>Payment Details</h4>
            <form className="add_assesment_form">
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Amount (in Rs)
                  </label>
                  <input
                    onChange={(e) => setAmount(e.target.value)}
                    type="text"
                    className="form-control"
                    id="amount"
                    name="amount"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Select Expert
                  </label>
                  <ReactSelect
                    id="expert"
                    name="expert"
                    options={options}
                    placeholder="Choose Expert"
                    isClearable
                    value={options.find(
                      (option: any) => option.value === expertInformation.uuid
                    )}
                    onChange={(option) =>
                      handleExpertDetails(option ? option.value : null)
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_type">
                    Select Booking Type
                  </label>
                  <Select
                    value={bookingType}
                    onChange={(e: any) => setBookingType(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="SINGLE">Single</option>
                    <option value="SUBSCRIPTION3">Subscription 3</option>
                    <option value="SUBSCRIPTION5">Subscription 5</option>
                    <option value="SUBSCRIPTION10">Subscription 10</option>
                  </Select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="payment">
                    Select Session Type
                  </label>
                  <Select
                    value={sessionType}
                    onChange={(e: any) => setSessionType(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="inperson">In-person</option>
                    <option value="video">Video</option>
                    <option value="call">Call</option>
                    <option value="chat">Chat</option>
                  </Select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mb-3 mt-4">
                  <h4>Customer Details</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="payment">
                    Name
                  </label>
                  <input
                    onChange={(e) =>
                      setCustomer((prev) => ({ ...prev, name: e.target.value }))
                    }
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="payment">
                    Contact
                  </label>
                  <input
                    onChange={(e) =>
                      setCustomer((prev) => ({
                        ...prev,
                        contact: e.target.value,
                      }))
                    }
                    type="text"
                    className="form-control"
                    id="contact"
                    name="contact"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="payment">
                    Email
                  </label>
                  <input
                    onChange={(e) =>
                      setCustomer((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                    type="text"
                    className="form-control"
                    id="email"
                    name="email"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mb-2 mt-4">
                  <h4>Notify</h4>
                </div>
                <div className="form-check form-check-inline col-md-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="notifyEmail"
                    onChange={(e) =>
                      setNotify((prev) => ({
                        ...prev,
                        email: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" htmlFor="notifyEmail">
                    Notify Via Email
                  </label>
                </div>

                <div className="form-check form-check-inline col-md-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="notifySMS"
                    onChange={(e) =>
                      setNotify((prev) => ({ ...prev, sms: e.target.checked }))
                    }
                  />
                  <label className="form-check-label" htmlFor="notifySMS">
                    Notify Via SMS
                  </label>
                </div>
              </div>
              {/* {isLink && (
                <Flex mt={5} mb={2} width="50%">
                  <input
                    value={value}
                    type="text"
                    className="form-control"
                    id="link"
                    name="link"
                  />
                  <button
                    type="button"
                    className="btn action-btn px-5 mx-2 submit-button"
                    onClick={onCopy}
                  >
                    {hasCopied ? "Copied!" : "Copy"}
                  </button>
                </Flex>
              )} */}

              <button
                type="button"
                className="btn action-btn mt-5 px-5 py-2 submit-button"
                onClick={handleGenerateLink}
              >
                Generate Link
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
